import { component } from 'picoapp'
import choozy from 'choozy'
import { on } from 'martha'

export default component((node) => {
  const { login, recover, recoverTrigger, recoverCancel, recoverSuccess } = choozy(node)
  const recoverIsTarget = window.location.hash.match(/\#recover/) ? true : false

  if (recoverIsTarget || recoverSuccess) {
    login.style.display = 'none'
    recover.style.display = 'block'
  } else {
    login.style.display = 'block'
  }

  on(recoverTrigger, 'click', (ev) => {
    ev.preventDefault()
    login.style.display = 'none'
    recover.style.display = 'block'
  })

  on(recoverCancel, 'click', (ev) => {
    ev.preventDefault()
    recover.style.display = 'none'
    login.style.display = 'block'
  })
})
